import './Contact.css';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";

function Contact() {
  const [inputData, setInputData] = useState({
    fname: "",
    lname: "",
    mobile: "",
    email: "",
    comments: "",
  });

  const navigate = useNavigate();

  const setInputValue = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const submitUserData = (e) => {
    e.preventDefault();
  
    const { fname, lname, mobile, email, comments } = inputData;
  
    // Basic validation
    if (!fname) {
      toast.error("First name is required");
      return;
    }
    if (!lname) {
      toast.error("Last name is required");
      return;
    }
    if (!mobile) {
      toast.error("Phone number is required");
      return;
    }
    if (!/^\d+$/.test(mobile)) {
      toast.error("Phone number must be numeric");
      return;
    }
    if (!email) {
      toast.error("Email is required");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    if (!comments) {
      toast.error("Comments/queries are required");
      return;
    }
  
    toast.success("Query Form Submitted Successfully");

   
    sendToWhatsApp();
    navigate(-1);
  };

  const sendToWhatsApp = () => {
    const { fname, lname, mobile, email, comments } = inputData;

    const message = `Hello, my name is ${fname} ${lname}.%0AHere are my details:%0APhone: ${mobile}%0AEmail: ${email}%0AComments/Queries: ${comments}`;

    const phoneNumber = "919994356072";
   
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;

    
    window.open(whatsappURL, '_blank');
  };

  return (
     <>
        <Helmet>
          <title>RP SMART ENERGY - ContactUs</title>
          <meta
            name="description"
            content="Get in touch with RP Smart Solar for expert consultation, Project Planning and Fast Installation of Solar Solution. Let's Power your future together."
          />
          <meta name="keywords" content="solar, consultation , installation, RP Smart Solar, future, touch, Solution, Project" />
        </Helmet>
    <div className="container mb-3">
      <p className='mt-2 navhis'>
        <Link to={'/'} className='text-decoration-none'>HOME</Link> / <Link to={'/contact'} className='text-decoration-none'>CONTACT US</Link>
      </p>
      <h3 className="text-center">Contact Us</h3>
      <ul className="list-unstyled mt-3">
        <li className="licolor">We're happy to answer queries or help you with returns.</li>
        <li className="licolor">Please fill out the form below if you need assistance.</li>
      </ul>
      <form onSubmit={submitUserData}>
        <div className="row">
          <div className="col col-md-4 col-sm-12">
            <label htmlFor="fname">First Name*</label>
            <input type="text" id="fname" className="form-control" name="fname" value={inputData.fname} onChange={setInputValue} />
          </div>
          <div className="col-12 col-md-4">
            <label htmlFor="lname">Last Name*</label>
            <input type="text" id="lname" className="form-control" name="lname" value={inputData.lname} onChange={setInputValue} />
          </div>
        </div>
        <div className="row">
          <div className="col col-md-4 col-sm-12">
            <label htmlFor="mobile">Phone Number*</label>
            <input type="tel" id="mobile" className="form-control" name="mobile" value={inputData.mobile} onChange={setInputValue} />
          </div>
          <div className="col-12 col-md-4">
            <label htmlFor="email">Email Address</label>
            <input type="email" id="email" className="form-control" name="email" value={inputData.email} onChange={setInputValue} />
          </div>
        </div>
        <div className="row">
          <div className="col col-md-8 col-sm-12">
            <div className="mb-3">
              <label htmlFor="comments" className="form-label">Comments/Queries</label>
              <textarea id="comments" className="form-control" rows="3" name="comments" value={inputData.comments} onChange={setInputValue}></textarea>
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary margincenter">SUBMIT FORM</button>
      </form>
      <ToastContainer position="top-center" />
    </div>
    </>
  );
}

export default Contact;
